import gql from 'graphql-tag';

export default gql`
query PROFILE($companyKsuid: String!) {
  myEmployeeProfile(companyKsuid: $companyKsuid) {
    accessType
    accessTypes
    company {
      address
      aliasName
      email
      handle
      hasConsentedCustomer
      isDofEligible
      isPodfEligible
      ksuid
      logo {
        fileName
        uploadedAt {
          date
        }
        url {
          full
        }
      }
      metadata
      name
      phoneNumber
      status
      type
    }
    email
    ksuid
    name
    user {
      phoneNumber
      email
      defaultLocale
    }
  }
  companySettings(companyKsuid: $companyKsuid) {
    companyDocuments {
      ktpFile {
        fileName
        uploadedAt {
          datetime
        }
        url {
          full
        }
      }
      npwpFile {
        fileName
        uploadedAt {
          datetime
        }
        url {
          full
        }
      }
      sppkpFile {
        fileName
        uploadedAt {
          datetime
        }
        url {
          full
        }
      }
    }
  }
  companyBankAccounts(companyKsuid: $companyKsuid) {
    ksuid
    accountHolder
    accountNumber
    isDefault
    bank {
      ksuid
      name
    }
  }
  enrolledCompanies {
    ksuid
  }
}
`;
